<template>
	<div class="report-refer">
		<div class="title-name">
			<p>查询前请选择医院及就诊人</p>
			<p class="notic">
				请使用电子健康卡就诊后查看检验检查报告，如需查看历史就诊情况请打开我的-健康档案功能进行查询
			</p>
		</div>
		<div class="drop-box">
			<!-- 医院 -->
			<!-- <a-dropdown :overlayStyle="style">
        <a class="ant-dropdown-link">
          {{ HospitalName }}
          <a-icon type="down" />
        </a>
        <a-menu
          slot="overlay"
          style="position:relative;"
        >
          <a-menu-item
            v-for="item in hospitalSelectOptions"
            :key="item.id"
            @click="changeHospital(item)"
          >
            <a href="javascript:;">{{ item.name }}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown> -->
			<a-select
				show-search
				:placeholder="HospitalName"
				option-filter-prop="children"
				style="width: 400px"
				:filter-option="filterOption"
				@change="handleChange"
			>
				<a-select-option
					v-for="item in hospitalSelectOptions"
					:key="item.id"
					:value="item.id"
				>
					{{ item.name }}
				</a-select-option>
			</a-select>
			<!-- 就诊人 -->
			<a-dropdown>
				<a class="ant-dropdown-link">
					{{ patientName }}
					<a-icon type="down" />
				</a>
				<a-menu slot="overlay">
					<a-menu-item
						v-for="it in patientOptions"
						:key="it.cardNo"
						@click="changePatient(it)"
					>
						<a href="javascript:;">{{ it.name }}</a>
					</a-menu-item>
				</a-menu>
			</a-dropdown>

			<!-- 类型 -->
			<a-dropdown :overlayStyle="style">
				<a class="ant-dropdown-link">
					{{ sortName }}
					<a-icon type="down" />
				</a>
				<a-menu slot="overlay">
					<a-menu-item
						v-for="item in sortList"
						:key="item.id"
						@click="changeSort(item)"
					>
						<a href="javascript:;">{{ item.name }}</a>
					</a-menu-item>
				</a-menu>
			</a-dropdown>
		</div>
		<div class="time">
			<!-- 选择时间 -->
			<a-range-picker
				size="large"
				@change="handlechange"
				:disabled-date="disabledDate"
			>
				<!-- <template slot="renderExtraFooter">extra footer</template> -->
			</a-range-picker>
      <!-- 报告对比 -->
      <span v-if="compareFlag === 1" class="compare-btn" @click.stop="getReportList()">
        <img :src="compareImg" style="width: 153px; height: 70px;" alt="">
      </span>
		</div>
    <div v-if="compareFlag > 1" style="margin: 20px 0;">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <a @click="compareFlag=1">报告查询</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-if="compareFlag > 1">
          <a @click="compareFlag=2">报告对比</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-if="compareFlag === 3">报告详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>

    <template v-if="compareFlag === 1">
		<template v-if="reserveList.length > 0">
			<div class="reserveList">
				<div
					class="list"
					v-for="(i, index) in reserveList"
					:key="index"
					@click="topage(i)"
				>
					<template v-if="i.bizType != 3">
						<div class="title">
							<p>{{ i.name }}</p>
							<span
								>申请时间:{{ calcTime(i.reqTime) || '' }}</span
							>
						</div>
						<div class="content">
							<p>科室:{{ i.deptName || '' }}</p>
							<p>送检医生:{{ i.applyDoctorName || '' }}</p>
						</div>
					</template>

					<template v-else>
						<div class="title">
							<p>{{ i.bizTypeName }}报告</p>
							<span
								>体检时间:{{ calcTime(i.reqTime) || '' }}</span
							>
						</div>
						<div class="content">
							<p>体检项目:{{ i.name || '' }}</p>
							<p>体检医生:{{ i.reqDoctorName || '' }}</p>
						</div>
					</template>
				</div>
			</div>

			<div v-if="reserveList.length > 0">
				<a-pagination
					show-quick-jumper
					:current="currPage"
					:total="totalCount"
					:defaultPageSize="form.pageSize"
					@change="onChange"
				/>
				<br />
			</div>
		</template>
		<div v-else class="nodata">暂无报告</div>
    </template>

    <!-- 报告对比 -->
    <template v-if="compareFlag === 2">
      <ComReport :list="reportList" @getReportDetail="getReportDetail"/>
    </template>

    <!-- 报告详情 -->
    <template v-if="compareFlag === 3">
      <ComDetail :chartList="chartList" />
    </template>
	</div>
</template>
<script>
import {
	hospitalSelect,
	reserve,
	byHospId,
	getUserinured,
	saveUserinured,
} from '@/api/register'
import { getTerm, getContrastReportList, getContrastReportDetail } from '@/api/report'
import { ls } from '@/utils/tool'
import { cancel } from '@/api/registered'
import { startRefund } from '@/api/payment'
// import noData from "@/components/NoData";
import moment from 'moment'
import ComReport from './components/comReport.vue'
import ComDetail from './components/comDetail.vue'
var jsTime
export default {
	components: {
		// noData,
    ComReport,
    ComDetail
	},
	data() {
		return {
			hospitalSelectOptions: [],
			patientOptions: [],
			HospitalName: '',
			patientName: '',
			reserveList: [],
			form: {
				cardNo: '',
				hospitalId: '',
				pageNum: 1,
				pageSize: 10,
				beginDate: '',
				endDate: '',
				recordId: 0,
				bizType: '',
			},
			sortName: '全部',
			sortList: [
				{ name: '全部', id: '' },
				{ name: '检查报告', id: 1 },
				{ name: '检验报告', id: 2 },
				{ name: '体检报告', id: 3 },
				{ name: '住院报告', id: 4 },
				{ name: '细菌培养报告', id: 5 },
				{ name: '药敏试验报告', id: 6 },
			],
			sysUser: JSON.parse(localStorage.getItem('sysUser')),
			currPage: 1,
			totalCount: 1,
			style: {
				maxHeight: '430px',
				overflow: 'scroll',
				overflowX: 'hidden',
			},
      // 是否展示报告对比按钮
      compareFlag: 1,
      compareImg: require('@/assets/user-center/compare-report.png'),
      reportList: [],
      reportDeatilList: [],
      chartList: {
        sgChart: {
          titleNames: ['身高'],
          titles: [],
          dataList: []
        },
        tzChart: {
          titleNames: ['体重'],
          titles: [],
          dataList: []
        },
        tzzsChart: {
          titleNames: ['体重指数'],
          titles: [],
          dataList: []
        },
        xyChart: {
          titleNames: ['舒张压', '收缩压'],
          titles: [],
          dataList: []
        },
        xdt: [],
        yg: []
      },
		}
	},
	created() {
		this.getData()
	},
	mounted() {},
	methods: {
		moment,
		handleChange(value) {
			this.form.hospitalId = value
			this.currPage = 1
			this.getReserve()
		},
		filterOption(input, option) {
			return (
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
			)
		},
		onChange(pageNumber) {
			this.form.pageNum = pageNumber
			this.getReserve()
		},
		disabledDate(current) {
			return current && current >= moment().endOf('day')
		},
		// 改变时间
		handlechange(date) {
			if (date.length > 0) {
				this.form.beginDate = this.dayjs(date[0]._d).format(
					'YYYY-MM-DD'
				)
				this.form.endDate = this.dayjs(date[1]._d).format('YYYY-MM-DD')
			} else {
				this.form.beginDate = ''
				this.form.endDate = ''
			}
			this.getReserve()
		},
		// 处理时间
		calcTime(val) {
			if (val) return val.substring(0, val.indexOf(' '))
			return ''
		},
		async getData() {
			//医院下拉列表
      const sysUser = JSON.parse(localStorage.getItem('sysUser'));
			let hospitalList = await hospitalSelect()
			this.hospitalSelectOptions = hospitalList.data
			this.patientOptions = sysUser.relationRecords

      const { HospitalName = '', hospitalId = '', patientName = '' } = this.$route.query;

			getUserinured({
				memberId: sysUser.id,
			})
				.then((res) => {
					this.HospitalName = HospitalName || res.data.hospital.name
					this.form.hospitalId = hospitalId || res.data.hospital.id
					this.patientName = patientName || res.data.record.name
					// this.cardNo = res.data.record.cardNo
					// this.recordId = res.data.record.id
				})
				.catch(() => {
					this.HospitalName = HospitalName || hospitalList.data[0].name
					this.form.hospitalId = hospitalId || hospitalList.data[0].id
					this.patientName = patientName || this.patientOptions[0].name
				})
				.finally(() => {
					this.patientOptions.forEach((item) => {
						if (item.name == this.patientName) {
							this.form.cardNo = item.cardNo
							this.form.recordId = item.recordId
						}
					})
					this.getReserve()
				})

			//获取就诊人列表

			// this.cardNo = this.patientOptions[0].cardNo;
		},
		//获取挂号记录
		async getReserve() {
      switch(this.compareFlag) {
        case 1:
          await this.getTermList()
          break;
        case 2:
          await this.getReportList()
          break;
        case 3:
          await this.getReportList()
          break;
        default:
          await this.getTermList()
      }
			console.log(this.form, 'save')
			saveUserinured({
				memberId: JSON.parse(localStorage.getItem('sysUser')).id,
				hospitalId: this.form.hospitalId,
				recordId: this.form.recordId,
			})
		},

    // 获取挂号记录
    async getTermList() {
      let res = await getTerm(this.form)
      if (res.code == 200) {
        this.reserveList = res.data.list
        this.totalCount = res.data.totalCount
      }
    },

		//选择医院
		changeHospital(val) {
			this.HospitalName = val.name
			this.form.hospitalId = val.id
			this.currPage = 1
			this.getReserve()
		},
		//选择就诊人
		changePatient(val) {
			this.patientName = val.name
			this.form.cardNo = val.cardNo
			this.form.recordId = val.recordId
			this.currPage = 1
			this.getReserve()
		},
		//选择类别
		changeSort(item) {
			this.sortName = item.name
			this.form.bizType = item.id
			this.getReserve()
		},
		// 筛选
		topage(row) {
			//   if (row.bizType == 5 || row.bizType == 6) {
			//     this.$message.warning('还在测试中！')
			//     return
			//   }
			console.log('row.bizType=======', row.bizType)
			// 类型 1 检查报告 2 检验报告 3 体检报告 row.hospitalId
			var url = {
				1:
					'/user-center/report-refer/inspect?id=' +
					row.id +
					'&hospitalId=' +
					row.hospitalId,
				2:
					'/user-center/report-refer/test?id=' +
					row.id +
					'&hospitalId=' +
					row.hospitalId,
				3:
					'/user-center/report-refer/exam?phyid=' +
					row.bizNo +
					'&hospitalId=' +
					row.hospitalId +
					'&recordId=' +
					row.recordId +
					'&reportId=' +
					row.id,
				5:
					'/user-center/report-refer/bacterial?id=' +
					row.id +
					'&hospitalId=' +
					row.hospitalId,
				6:
					'/user-center/report-refer/drug?id=' +
					row.id +
					'&hospitalId=' +
					row.hospitalId,
			}[row.bizType]

			if (row.bizType == 3) {
				let baseUrl = location.href.substring(
					0,
					location.href.indexOf('/#/') + 2
				)
				window.open(baseUrl + url, '_blank')
			} else {
				this.$router.push(url)
			}
		},

    // 获取报告对比列表
    async getReportList() {
      const { recordId, hospitalId, bizType } = this.form
      const params = {
        recordId,
        hospitalId,
        bizType
      }
      this.compareFlag = 2
      const res = await getContrastReportList(params)
      if (res.code === 200) {
        console.info(res)
        res.data.forEach((item, index) => {
          Object.assign(item, { key: index })
        })
        this.reportList = res.data
      } else {
        this.$message.warning(`${res.message}`);
      }
    },

    // 获取报告对比详情
    async getReportDetail(temp) {
      const ids = []
      temp.forEach(item => {
        ids.push(item.id)
      })
      this.compareFlag = 3
      const { recordId, hospitalId, bizType } = this.form
      const params = {
        recordId,
        hospitalId,
        bizType,
        ids
      }
      const res = await getContrastReportDetail(params)
      if (res.code === 200) {
        console.info(res)
        // this.reportDeatilList = res.data
        this.setChartData(res.data)
      } else {
        this.$message.warning(`${res.message}`);
      }
    },

    // 整理对比数据
    setChartData(data) {
      const { sg = [], tz = [], tzzs = [], xy = [], xdt = [], yg = [] } = data
      const { sgChart, tzChart, tzzsChart, xyChart }  = this.chartList

      const tempfunc = (list, idx = 1) => {
        const titles = []
        const arr = []
        if (idx === 1) {
          list.forEach(item => {
            titles.push(item.appDate)
            arr.push(item.peResult)
          })
          return { titles, arr }
        }
        if (idx === 2) {
          const arr2 = []
          list.forEach(item => {
            titles.push(item.appDate)
            arr.push(item.low)
            arr2.push(item.high)
          })
          return { titles, arr, arr2 }
        }
      }

      if (sg.length) {
        const { titles, arr } = tempfunc(sg)

        Object.assign(sgChart, { titles, dataList: [ arr ] })
      }

      if (tz.length) {
        const { titles, arr } = tempfunc(tz)

        Object.assign(tzChart, { titles, dataList: [ arr ] })
      }

      if (tzzs.length) {
        const { titles, arr } = tempfunc(tzzs)

        Object.assign(tzzsChart, { titles, dataList: [ arr ] })
      }

      if (xy.length) {
        const { titles, arr, arr2 } = tempfunc(xy, 2)

        Object.assign(xyChart, { titles, dataList: [ arr, arr2 ] })
      }

      this.chartList.xdt = xdt
      this.chartList.yg = yg

    },


	},
}
</script>
<style lang="less" scoped>
.report-refer {
	p {
		margin: 0;
	}
	.title-name {
		font-size: 20px;
		font-weight: 400;
		color: #3385ed;
		display: flex;
		align-items: center;
		p:first-child {
			flex: auto;
		}
		.notic {
			color: #fe312f;
			font-size: 14px;
		}
	}
	.ant-select {
		background: #f9f9f9;
		margin-right: 50px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		padding: 7px 16px;
		font-size: 16px;
		font-weight: 400;
		/deep/.ant-select-selection--single {
			background: #f9f9f9;
			border: 0;
			.ant-select-selection__placeholder {
				color: #3385ed;
			}
			.ant-select-selection-selected-value {
				color: #3385ed;
			}
		}
	}
	.drop-box {
		margin-top: 22px;
		a {
			background: #f9f9f9;
			border: 1px solid #eeeeee;
			border-radius: 4px;
			padding: 13px 16px;
			font-size: 16px;
			font-weight: 400;
			color: #3385ed;
			i {
				margin-left: 50px;
			}
		}
		a:not(:last-child) {
			margin-right: 50px;
		}
	}
	.time {
		padding-top: 30px;
	}

	.reserveList {
		padding-top: 20px;
		.list {
			cursor: pointer;
			padding: 20px;
			font-size: 16px;
			width: 80%;
			background: #ffffff;
			box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.3);
			border-radius: 6px;
			margin-bottom: 20px;
			.title {
				display: flex;
				align-items: center;
				padding-bottom: 5px;
				border-bottom: 1px solid #ccc;
				p {
					flex: 1;
				}
				span {
					font-size: 14px;
				}
			}
			.content {
				padding-top: 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}
	}
	.nodata {
		padding: 20px 0;
		text-align: center;
		font-size: 20px;
		color: #c0c4cc;
	}
}
.btn_item {
	width: 0.4rem;
}
.ant-select-dropdown {
	position: relative;
	left: 0 !important;
	top: 0 !important;
}

.compare-btn {
  margin: 0 20px;
  cursor: pointer;
}
</style>
